import useSWR from "swr";
import { adminPaymentsService } from "../data/admin-payments.service";
import type { AdminPaymentStatsDto } from "../data/admin-payments.service";

export function useAdminPaymentStats() {
  return useSWR<AdminPaymentStatsDto>("admin-payment-stats", async () => {
    const res = await adminPaymentsService.getStats();
    return res.data;
  });
}
